import React from 'react'

function PartnerOrder(props) {
  return <div>partnerOrder</div>
}

export default PartnerOrder
